import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Policies from '../components/policies/Policies'

import { fetchPoliciesIfNeeded } from '../actions/policies'

class PoliciesContainer extends Component {
  componentDidMount() {
    const { dispatch } = this.props
    dispatch(fetchPoliciesIfNeeded())
    window.scrollTo(0, 0)
  }

  render() {
    const { policies, isFetchingPolicies, dispatch } = this.props

    return (
      <div className="policies-container">
        {isFetchingPolicies && <div className="loading"></div>}
        {!isFetchingPolicies && (
          <div className="policies-list-wrapper">
            <Policies
              policies={policies}
              displayActions={true}
              dispatch={dispatch}
            />
          </div>
        )}
      </div>
    )
  }
}

PoliciesContainer.propTypes = {
  dispatch: PropTypes.func,
  policies: PropTypes.array.isRequired,
  isFetchingPolicies: PropTypes.bool.isRequired
}

export const mapStateToProps = state => ({
  policies: state.policies.items,
  isFetchingPolicies: state.policies.isFetching
})

export default connect(mapStateToProps)(PoliciesContainer)
export { PoliciesContainer as PoliciesDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/containers/Policies.js